import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/parametros/atualizacao-monetaria';

export default {
  cadastrar: async (acrescimosDescontos) => {
    return financeiroApi.post(`${PATH}`, acrescimosDescontos);
  },
  buscarPorId: async (key) => {
    return financeiroApi.get(`${PATH}/${encodeURIComponent(key)}`);
  },
  atualizar: async (id, acrescimosDescontos) => {
    return financeiroApi.put(`${PATH}/${id}`, acrescimosDescontos);
  },
  buscar: async (params) =>
    financeiroApi.get(`${PATH}`, {
      params,
    }),
};
